import React, { useEffect, useState } from 'react';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { url } from '../../../../../constants/url';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/UserContext';
import { Icon } from '@iconify/react';

function NetworkPart3(props) {

    const {
        certInNetworkVulnerabilities, setCertInNetworkVulnerabilities, certInNetworkCurrentPage,
        handleCertInNetworkDownload, handlePrevPage, handleNextPage, handleCertInNetworkCancel
    } = props

    const certInNetworkInitialVulnerabilityState = [
        {
            vulnerability: '',
            description: '',
            ipAddress: '',
            impact: '',
            risk: '',
            recommendation: '',
            reference: '',
            cwe: '',
            poc: [{ pocDesc: '', files: [], pocImageURL: '' }]
        }
    ];

    const [currentCertInNetworkPages, setCurrentCertInNetworkPages] = useState(0);
    const [certInSuggestions, setCertInSuggestions] = useState(certInNetworkVulnerabilities.map(() => []));
    const [certInNetworkData, setCertInNetworkData] = useState('')

    const {logout} = useAuth()

    useEffect(() => {
        if (certInNetworkVulnerabilities.length === 0) {
            setCertInNetworkVulnerabilities(certInNetworkInitialVulnerabilityState);
        }
    }, [certInNetworkVulnerabilities, setCertInNetworkVulnerabilities]);

    const handleChange = (vulIndex, e, isQuill = false) => {
        const newVulnerabilities = certInNetworkVulnerabilities.map((vul, index) => (
            index === vulIndex ? { ...vul, [e.target.name]: e.target.value } : vul
        ));
        if (e.target.name === 'vulnerability') {
            const value = e.target.value;

            if (value === '') {
                // Handle empty value case
                newVulnerabilities[vulIndex] = {
                    vulnerability: '',
                    description: '',
                    ipAddress: '',
                    impact: '',
                    risk: '',
                    recommendation: '',
                    reference: '',
                    cwe: '',
                    poc: [{ pocDesc: '', files: [], pocImageURL: '' }]
                };
                setCertInSuggestions(prev => {
                    const newSuggestions = [...prev];
                    newSuggestions[vulIndex] = [];
                    return newSuggestions;
                });
            } else if (Array.isArray(certInNetworkData)) {

                const matches = certInNetworkData.filter(vul => vul.vulnerability.toLowerCase().includes(value.toLowerCase()));
                setCertInSuggestions(prev => {
                    const newSuggestions = [...prev];
                    newSuggestions[vulIndex] = matches;
                    return newSuggestions;
                });

                const existingVulnerability = certInNetworkData.find(vul => vul.vulnerability === value);
                if (existingVulnerability) {
                    newVulnerabilities[vulIndex] = { ...existingVulnerability };
                    setCertInSuggestions(prev => {
                        const newSuggestions = [...prev];
                        newSuggestions[vulIndex] = [];
                        return newSuggestions;
                    });
                }
            } else {
                console.error("vulnerabilityData is not an array:", certInNetworkData);
            }
        }
        setCertInNetworkVulnerabilities(newVulnerabilities);
    };

    const handleSuggestionClick = (vulIndex, suggestion) => {
        const newVulnerabilities = certInNetworkVulnerabilities.map((vul, index) => (
            index === vulIndex ? { ...suggestion } : vul
        ));
        setCertInNetworkVulnerabilities(newVulnerabilities);
        setCertInSuggestions(prev => {
            const newSuggestions = [...prev];
            newSuggestions[vulIndex] = [];
            return newSuggestions;
        });
    };

    const addVulnerabilityField = () => {
        const newVulnerabilities = [
            ...certInNetworkVulnerabilities,
            {
                vulnerability: '',
                description: '',
                ipAddress: '',
                impact: '',
                risk: '',
                recommendation: '',
                reference: '',
                cwe: '',
                poc: [{ pocDesc: '', files: [], pocImageURL: '' }]
            }
        ];
        setCertInNetworkVulnerabilities(newVulnerabilities);
        setCertInSuggestions([...certInSuggestions, []]);
        setCurrentCertInNetworkPages(certInNetworkVulnerabilities.length);
    };

    const removeVulnerabilityField = (index) => {
        const newVulnerabilities = certInNetworkVulnerabilities.filter((_, i) => i !== index);
        setCertInNetworkVulnerabilities(newVulnerabilities);
        setCertInSuggestions(prev => prev.filter((_, i) => i !== index));
        setCurrentCertInNetworkPages(prev => Math.max(prev - 1, 0));
    };

    const handleDescription = (vulIndex, pocIndex, e) => {
        const newVulnerabilities = certInNetworkVulnerabilities.map((vul, index) => (
            index === vulIndex ? {
                ...vul,
                poc: vul.poc.map((poc, i) => i === pocIndex ? { ...poc, [e.target.name]: e.target.value } : poc)
            } : vul
        ));
        setCertInNetworkVulnerabilities(newVulnerabilities);
    };

    const handlePOCImageChange = (vulIndex, pocIndex, e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            const newVulnerabilities = certInNetworkVulnerabilities.map((vul, index) => (
                index === vulIndex ? {
                    ...vul,
                    poc: vul.poc.map((poc, i) => i === pocIndex ? {
                        ...poc,
                        files,
                        pocImageURL: URL.createObjectURL(files[0])
                    } : poc)
                } : vul
            ));
            setCertInNetworkVulnerabilities(newVulnerabilities);
        }
    };

    const addPOCField = (index) => {
        const newVulnerabilities = certInNetworkVulnerabilities.map((vul, i) => (
            i === index ? {
                ...vul,
                poc: [...vul.poc, { pocDesc: '', files: [], pocImageURL: '' }]
            } : vul
        ));
        setCertInNetworkVulnerabilities(newVulnerabilities);
    };

    const removePOCDetails = (vulIndex, pocIndex) => {
        const newVulnerabilities = certInNetworkVulnerabilities.map((vul, index) => (
            index === vulIndex ? {
                ...vul,
                poc: vul.poc.filter((_, i) => i !== pocIndex)
            } : vul
        ));
        setCertInNetworkVulnerabilities(newVulnerabilities);
    };

    const resetVulnerabilities = () => {
        if (certInNetworkVulnerabilities.length === 0) {
            setCertInNetworkVulnerabilities([]);
        }
    };

    const fetchVulnerabilityDetails = async () => {
        try {
            const response = await fetch(`${url}/fetchstoredvulnerabilitysuggestion`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include'
            });
            if (response.ok) {
                const suggestionData = await response.json();
                console.log(suggestionData);

                const newVulnerabilityData = suggestionData.map(item => ({
                    vulnerability: item.vulnerabilityName || '',
                    description: item.description || '',
                    ipAddress: item.ipAddress || '',
                    impact: item.impact || '',
                    risk: item.risk || '',
                    recommendation: item.recommendation || '',
                    reference: item.reference || '',
                    cwe: item.cwe || '',
                    poc: Array.isArray(item.POCDetails) ? item.POCDetails : [{ pocDesc: '', files: [], pocImageURL: '' }]
                }));

                setCertInNetworkData(newVulnerabilityData)
                return
            }
            if (response.status === 440) {
                logout()
                toast.error("User logout due to inactivity", {
                  position: 'top-right',
                  autoClose: 2500,
                  pauseOnHover: false,
                });
                return
              }
        } catch (error) {
            console.error("Error fetching vulnerability data:", error);
        }
    };

    useEffect(() => {
        fetchVulnerabilityDetails()
    }, []);



    const renderVulnerability = (vul, vulIndex) => (
        <div key={vulIndex}>
            <div className='report_part3_inputs'>
                <div className='report_part2_leftside'>
                    <div className='report_input'>
                        <label>Vulnerability name</label>
                        <input
                            type='text'
                            name="vulnerability"
                            placeholder='Vulnerability name'
                            value={vul.vulnerability}
                            onChange={(e) => {
                                handleChange(vulIndex, e)
                            }}
                        />

                        {certInSuggestions[vulIndex] && certInSuggestions[vulIndex].length > 0 && (
                            <ul className='suggestions'>
                                {certInSuggestions[vulIndex].map((suggestion, index) => (
                                    <li key={index} onClick={() => handleSuggestionClick(vulIndex, suggestion)}>
                                        {suggestion.vulnerability}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <div className='report_input'>
                        <label>Risk/Impact</label>
                        <textarea name="impact" placeholder='Risk or Impact' value={vul.impact} onChange={(e) => {
                            handleChange(vulIndex, e)
                        }} />
                    </div>
                    <div className='report_input'>
                        <label>Reference</label>
                        <input type='text' name="reference" placeholder='Reference Link' value={vul.reference} onChange={(e) => {
                            handleChange(vulIndex, e)
                        }} />
                    </div>

                    <div className='report_input'>
                        <label>Severity</label>
                        <input type='text' name="risk" placeholder='Severity' value={vul.risk} onChange={(e) => {
                            handleChange(vulIndex, e)
                        }} />
                    </div>

                    <div className='report_input'>
                        <label>CWE</label>
                        <input type='text' name="cwe" placeholder='CWE' value={vul.cwe} onChange={(e) => {
                            handleChange(vulIndex, e)
                        }} />
                    </div>



                </div>

                <div className='report_part2_rightside'>
                    <div className='report_input'>
                        <label>Description</label>
                        <textarea name="description" placeholder='Description' value={vul.description} onChange={(e) => {
                            handleChange(vulIndex, e)
                        }} />
                    </div>

                    <div className='report_input'>
                        <label>Recommendation</label>
                        <textarea name="recommendation" placeholder='Description' value={vul.recommendation} onChange={(e) => {
                            handleChange(vulIndex, e)
                        }} />
                    </div>

                    <div className='report_input'>
                        <label>Affected IP</label>
                        <textarea name="ipAddress" placeholder='Affected IP Address' value={vul.ipAddress} onChange={(e) => {
                            handleChange(vulIndex, e)
                        }} />
                    </div>


                </div>
            </div>
            <hr />
            {Array.isArray(vul.poc) && vul.poc.map((desc, pocIndex) => (
                <div key={pocIndex}>
                    <div className='report_part3_poc'>
                        <div className='report_part2_leftside'>
                            <div className='report_input'>
                                <label>Description</label>
                                <textarea
                                    name="pocDesc"
                                    placeholder='POC Description'
                                    value={desc.pocDesc}
                                    onChange={(e) => {
                                        handleDescription(vulIndex, pocIndex, e)
                                    }}
                                    style={{ height: "90px" }}
                                />
                            </div>
                        </div>
                        <div className='report_part2_rightside'>
                            <div className='report_input'>
                                <label>Proof of Concept</label>

                                <p style={{ fontSize: "11.5px", fontStyle: "italic", textAlign: "justify", marginTop: "5px", marginLeft: "10px" }}>To include multiple Proof of Concept (POC) for the same description, click the "Add POC" button below. There's no need to provide a description; just upload your image.</p>
                                {!desc.pocImageURL && (
                                    <input
                                        type="file"
                                        name="file"
                                        onChange={(e) => handlePOCImageChange(vulIndex, pocIndex, e)}
                                    />
                                )}

                                {desc.pocImageURL && (
                                    <div>
                                        <img src={desc.pocImageURL} alt="Uploaded poc" style={{ width: '200px', height: '100px' }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div>
                        {pocIndex !== vul.poc.length - 0 && (
                            <button style={{
                                justifyContent: "center", Width: "100px", alignItems: "center", marginTop: "0px", marginLeft: "30px", backgroundColor: "rgba(223, 30, 20, 0.899)", fontSize: "11px", color: "rgb(255, 255, 255)", fontWeight: "bold", borderRadius: "4px", padding: "4px 4px"
                            }} onClick={() => {
                                removePOCDetails(vulIndex, pocIndex)

                            }}><span style={{ marginRight: "5px" }}><FontAwesomeIcon icon={faTrash} /></span>Delete POC</button>
                        )}
                    </div>
                </div>
            ))}

            <button className='add_more_button' style={{ marginLeft: "70px", width: "85px" }} onClick={() => {
                addPOCField(vulIndex)

            }}><span style={{ marginRight: "5px" }}><FontAwesomeIcon icon={faPlus} /></span>Add POC</button>
            <hr />
            {vulIndex !== certInNetworkVulnerabilities.length - 0 && (
                <button className='remove_more_button' onClick={() => {
                    removeVulnerabilityField(vulIndex)

                }}><span style={{ marginRight: "5px" }}><FontAwesomeIcon icon={faTrash} /></span>Delete Vulnerability</button>
            )}
        </div>
    );

    return (
        <div className='report_part3'>
            <div className='report_part3_content'>
                <div className='report_part3_heading'>
                    <h1>Part 3 Network Cert-In Format</h1>
                </div>
                <div className='report_part3_input'>
                    {certInNetworkVulnerabilities && certInNetworkVulnerabilities.length > 0 &&
                        certInNetworkVulnerabilities[currentCertInNetworkPages] ? (
                        renderVulnerability(certInNetworkVulnerabilities[currentCertInNetworkPages], currentCertInNetworkPages)
                    ) : (
                        <p>Click on below button to add vulnerabilities</p>
                    )
                    }

                </div>

                <div className='pagination_controls'>
                    <div className='pagination_buttons'>
                        {certInNetworkVulnerabilities.map((_, index) => (
                            <button
                                key={index}
                                className={index === currentCertInNetworkPages ? 'active' : ''}
                                onClick={() => setCurrentCertInNetworkPages(index)}>
                                {index + 1}
                            </button>
                        ))}
                    </div>
                    <div className='pagination_vulnerability_button'>
                        <button className='add_more_vulnerabilities' style={{ backgroundColor: "#2E89E4", marginBottom: "10px", justifyContent: "center", alignSelf: "center", marginTop: "5px", marginLeft: "30px" }} onClick={addVulnerabilityField}><span style={{ marginRight: "5px" }}><FontAwesomeIcon icon={faPlus} /></span>Add</button>
                    </div>
                </div>
                <div className='report_part1_button'>
                    <button onClick={handlePrevPage} disabled={certInNetworkCurrentPage === 1}><Icon icon="stash:arrow-left-light"  style={{ color: "#254fe3" }} className="prev_icon" /></button>

                    {/*<button style={{ fontSize: "13px", marginRight: "20px" }} onClick={handlePrevPage} disabled={certInNetworkCurrentPage === 1}>Prev</button>*/}
                    <button className='part1_cancel_button' onClick={() => {
                        resetVulnerabilities();
                        handleCertInNetworkCancel()
                    }}>Cancel</button>

                    <button className='part1_upload_button' onClick={handleCertInNetworkDownload}>Download</button>
                    {/*<button style={{ fontSize: "13px", marginLeft: "20px" }} onClick={handleNextPage} disabled={certInNetworkCurrentPage === 3}>Next</button>*/}
                    <button onClick={handleNextPage} disabled={certInNetworkCurrentPage === 3}><Icon icon="stash:arrow-right-light" className="next_icon" /></button>

                </div>
            </div>

        </div>
    )
}

export default NetworkPart3
